








































































import Vue from "vue";
import {Component} from "vue-property-decorator";
import FormEditor from "@/views/FormEditor.vue";
import Configuration from "@/shared/Configuration";

@Component({
    components: {FormEditor}
})
export default class App extends Vue {
    version: string = null;
    date: string = null;
    initialized: boolean = false;
    aboutDialog: boolean = false;

    showAbout() {
        this.aboutDialog = true;
    }

    async beforeCreate() {
        await Configuration.init(this.$store);
        this.$vuetify.theme.dark = this.$store.state.settings.dark;
        this.initialized = true;
    }

    async beforeMount() {
        this.version = require("../package.json").version;
        this.date = require("../package.json").date;
    }

    mounted() {

    }

    activeInfo() {
        return "Admin";
        // if (_.isNil(this.$store.state.global.project)) {
        //     return '';
        // }
        // return `<strong>Dataset:</strong> ${this.$store.state.global.project.metadata.name}, ${this.$store.state.global.project.dataset.nodes.length} nodes and ${this.$store.state.global.project.dataset.edges.length} links.`
    }

    backendInfo() {
        // const prefs = Configuration.getUserPreferences();
        // if (prefs.useLocalStore) {
        //     return '<strong>Backend:</strong> Local Store';
        // } else {
        //     return `<strong>Backend:</strong> <a class="black--text no-underline" href='${prefs.serviceAddress}' target='_blank'>Remote Service</a>`
        // }
    }

    toggleTheme() {
        const settings = this.$store.state.settings;
        settings.dark = !settings.dark;
        Configuration.setAndSaveSettings(this.$store, settings);
        this.$router.go(0);
    }

    goAdmin() {
        this.$router.push({path: "/admin"});
    }
}

